import {
  IFavoritesList,
  IListItemAction,
  INewListItemsActionResponse,
  INewListRequest,
  IDeleteListActionResponse,
} from "@wbmason/my-list-service";
import { useCallback, useEffect, useRef, useState } from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { SlideInSelection } from "slideinselection";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { SuccessAlert } from "wbm-generic-components";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Button, TextBox } from "wbm-inputs";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { WBMSelectionCard } from "wbm-selection-card";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { ModalPopup } from "wbm-generic-components";
import ConfigProps from "../../constants/configProps";
import { WbmMainHeaderApi } from "@wbmason/main-header-api";
import {
  DisplayAsList,
  FavoritesListPermissions,
  FavoritesListType,
  FavoritesSortCode,
} from "../../enums/CreateListSettings";
import ConfigPropService from "../../utilities/configPropService";
import DigitalDataService from "../../utilities/digitalDataService";
import { EXTERN_MY_LISTS_SERVICE } from "../../utilities/myListsService";
import Icon from "../icon/icon";
import "./addList.scss";
import { ListAction } from "@wbmason/my-list-service/constants/enums";
import { ICopyListActionResponse } from "my-list-service";
import ScrollBarService from "../../utilities/scrollBarService";
import { AdobeEvent } from "@wbmason/digital-data-service/constants/enums";
import { ErrorAlert } from "../ErrorAlert/ErrorAlert";

export interface IAddListProps {
  createList: (response: IFavoritesList) => void;
  createPopulatedList?: (response: INewListItemsActionResponse) => void;
  updateList?: (response: IFavoritesList) => void;
  itemsToAdd?: IListItemAction[] | null;
  actionType?: number;
  manageGroupLists: boolean;
  authorized: boolean;
  loginHref: string;
  productSet?: INewListRequest | null;
  listAction?: ListAction;
  pageName?: string;
}

const favoriteListPermission = "Available";
const favoriteListSortCode = "Brand A-Z";
const defaultContentType = "Item";

const DISPLAY_AS_LIST_ARRAY = Object.keys(DisplayAsList).filter((key) =>
  isNaN(Number(key)),
);
const FAVORITES_SORT_CODES_ARRAY = Object.keys(FavoritesSortCode);
const FAVORITES_LIST_TYPE_ARRAY = Object.keys(FavoritesListType);

export function AddList(props: IAddListProps) {
  const SIS = useRef<SlideInSelection>(null);
  const [showListTypeSelectionCard, setShowListTypeSelectionCard] =
    useState(false);
  const [showListPermissionSelectionCard, setShowListPermissionSelectionCard] =
    useState(false);
  const [showContentSelection, setShowContentSelection] = useState(false);
  const [showSortCodeSelectionCard, setShowSortCodeSelectionCard] =
    useState(false);
  const [headerText, setHeaderText] = useState("Add List");
  const [listName, setListName] = useState("");
  const [listNameErrorMsg, setListNameErrorMsg] = useState("");
  const [isListNameValid, setIsListNameValid] = useState<boolean | null>(null);
  const [favoriteListTypeSelected, setFavoriteListTypeSelected] = useState(0);
  const [favoriteListPermissionSelected, setFavoriteListPermissionSelected] =
    useState(0);
  const [favoriteSortCodeSelected, setFavoriteSortCodeSelected] = useState(0);
  const [contentTypeSelected, setContentTypeSelected] = useState(0);

  const [selectedListTypeOption, setSelectedListTypeOption] = useState<
    FavoritesListType | string
  >(FavoritesListType.Personal);
  const [selectedContentType, setSelectedContentType] =
    useState(defaultContentType);
  const [selectedListPermission, setSelectedListPermission] = useState("");
  const [selectedListSortCode, setSelectedListSortCode] =
    useState(favoriteListSortCode);
  const [listAddLoading, setListAddLoading] = useState(false);

  const [showListTypeOptions, setShowListTypeOptions] = useState(false);
  const [listPermissions, setListPermissions] = useState<string[]>([]);
  const [manageRestrictions, setManageRestrictions] = useState(false);
  const [createListError, setCreateListError] = useState(false);
  const [forceOpen, setForceOpen] = useState(false);
  const [isSecondary, setIsSecondary] = useState(true);
  const [showDeleteListmodal, setShowDeleteListModal] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);

  useEffect(() => {
    if (props.productSet) {
      setIsSecondary(false);
    }
  }, [props.productSet]);

  const handleManageList = () => {
    if (!listName) {
      setListNameErrorMsg("Required");
      setIsListNameValid(false);
      return;
    }
    const index = listPermissions.findIndex((val) =>
      val.includes(selectedListPermission),
    );
    const newListRequest: INewListRequest = {
      name: listName,
      listType: {
        name: selectedListTypeOption.toString(),
      },
      assignmentType: {
        name: selectedListPermission
          ? Object.keys(FavoritesListPermissions)[index].toString()
          : favoriteListPermission,
        displayName: selectedListPermission,
      },
      sortCode: {
        code: selectedListSortCode
          ? FavoritesSortCode[
              selectedListSortCode as keyof typeof FavoritesSortCode
            ]
          : favoriteListSortCode,
        description: selectedListSortCode,
      },
      displayAsList: selectedContentType
        ? ConfigPropService.isYesOrTrue(
            DisplayAsList[selectedContentType as keyof typeof DisplayAsList],
          )
        : false,
      ruleBasedSetFlag: selectedContentType !== defaultContentType,
    };
    setListAddLoading(true);

    const pageName = props.pageName || "add-list-slideout";

    if (props.productSet && props.productSet.id) {
      if (props.listAction === ListAction.Edit) {
        EXTERN_MY_LISTS_SERVICE()
          .updateList(props.productSet.id, newListRequest)
          .subscribe(
            (response: IFavoritesList) => {
              setListAddLoading(false);
              SIS?.current?.slideItOut(true);
              props.updateList && props.updateList(response);
            },
            () => {
              setCreateListError(true);
              setListAddLoading(false);
            },
          );
      } else if (props.listAction === ListAction.Copy) {
        EXTERN_MY_LISTS_SERVICE()
          .copyList(props.productSet.id, newListRequest)
          .subscribe(
            (response: ICopyListActionResponse) => {
              setListAddLoading(false);
              SIS?.current?.slideItOut(true);
              WbmMainHeaderApi.copyList(response);
            },
            () => {
              setCreateListError(true);
              setListAddLoading(false);
            },
          );
      }
    } else if (!props.itemsToAdd || props.itemsToAdd.length <= 0) {
      DigitalDataService.addNewList();
      EXTERN_MY_LISTS_SERVICE()
        .addNewList(newListRequest, pageName)
        .subscribe(
          (response: IFavoritesList) => {
            setListAddLoading(false);
            SIS?.current?.slideItOut(true);
            DigitalDataService.setEvent(
              {
                event: AdobeEvent.ShoppingListCreated,
              },
              true,
            );
            props.createList(response);
          },
          () => {
            setCreateListError(true);
            setListAddLoading(false);
          },
        );
    } else {
      DigitalDataService.addNewList();
      DigitalDataService.listItemAdded();
      EXTERN_MY_LISTS_SERVICE()
        .addNewPopulatedList(
          newListRequest,
          props.itemsToAdd,
          props.actionType || 0,
        )
        .subscribe(
          (response: INewListItemsActionResponse) => {
            setListAddLoading(false);
            SIS?.current?.slideItOut(true);
            props.createPopulatedList && props.createPopulatedList(response);
          },
          () => {
            setCreateListError(true);
            setListAddLoading(false);
          },
        );
    }
  };

  useEffect(() => {
    const configPropsSub = ConfigPropService.get([
      ConfigProps.ManageRestrictions,
      ConfigProps.ListAssignmentRenameInclusion,
      ConfigProps.ListAssignmentRenameExclusion,
      ConfigProps.ListAssignmentRenameReInclusion,
    ]).subscribe((configProps) => {
      setShowListTypeOptions(
        props.manageGroupLists ||
          ConfigPropService.isYesOrTrue(
            configProps[ConfigProps.ManageRestrictions],
          ),
      );

      setManageRestrictions(
        ConfigPropService.isYesOrTrue(
          configProps[ConfigProps.ManageRestrictions],
        ),
      );

      setListPermissions([
        configProps[ConfigProps.ListAssignmentRenameInclusion] || "Available",
        configProps[ConfigProps.ListAssignmentRenameExclusion] || "Restrict",
        configProps[ConfigProps.ListAssignmentRenameReInclusion] ||
          "Override Restrict",
      ]);
    });

    return () => {
      configPropsSub.unsubscribe();
    };
  }, [props.manageGroupLists]);

  const onEnterAddListSlideIn = useCallback(() => {
    setIsListNameValid(null);
    setListNameErrorMsg("");
    setListName(
      props.listAction === ListAction.Edit
        ? props.productSet!.name
        : props.listAction === ListAction.Copy
        ? `${props.productSet?.name} - Copy`
        : "",
    );
    setSelectedListTypeOption(
      props.listAction === ListAction.Edit
        ? props.productSet!.listType.name
        : FavoritesListType.Personal,
    );
    setSelectedContentType(
      props.productSet?.ruleBasedSetFlag
        ? DisplayAsList[DisplayAsList.Category]
        : defaultContentType,
    );
    setSelectedListPermission(
      props.listAction === ListAction.Edit
        ? props.productSet!.assignmentType.displayName
        : listPermissions[0],
    );
    setSelectedListSortCode(
      props.listAction === ListAction.Edit
        ? props.productSet!.sortCode.description
        : favoriteListSortCode,
    );
    setHeaderText(
      props.listAction === ListAction.Edit
        ? "List Settings"
        : props.listAction === ListAction.Copy
        ? "Copy List"
        : "Add List",
    );
  }, [listPermissions, props.listAction, props.productSet]);

  useEffect(() => {
    if (props.productSet) {
      setForceOpen(true);
      onEnterAddListSlideIn();
    }
  }, [props.productSet, onEnterAddListSlideIn]);

  const shouldShowDeleteLink = () => {
    return (
      props.productSet?.allowDelete &&
      (props.productSet?.listType.name === "Personal" ||
        props.manageGroupLists ||
        manageRestrictions)
    );
  };

  const deleteList = () => {
    if (props.productSet?.id) {
      setShowSpinner(true);
      EXTERN_MY_LISTS_SERVICE()
        .deleteList(JSON.stringify(props.productSet.id), props.pageName)
        .subscribe(
          (response: IDeleteListActionResponse) => {
            WbmMainHeaderApi.deleteList(response);
            SIS?.current?.slideItOut(true);
            setShowDeleteListModal(false);
            setShowSpinner(false);
          },
          () => {
            setShowErrorAlert(true);
            setShowDeleteListModal(false);
            setShowSpinner(false);
          },
        );
    }
  };

  return props.authorized ? (
    <div className="add-list-container">
      <SlideInSelection
        ref={SIS}
        forceOpen={forceOpen}
        button={
          <div>
            <button
              className="btn-color add-list-btn"
              onClick={onEnterAddListSlideIn}
            >
              <Icon>add_circle_outline</Icon>
              <span className="add-list">Add List</span>
            </button>
          </div>
        }
        header={<div className="list-sis-header">{headerText}</div>}
        containerId={"body"}
        appendRemoveContainerWidth={(isOpen: boolean) => {
          ScrollBarService.applyModalOpen(isOpen, "create list", true);
        }}
        onInsufficientAuthAddressSelect={
          !showListTypeSelectionCard &&
          !showContentSelection &&
          !showListPermissionSelectionCard &&
          !showSortCodeSelectionCard
        }
        isSecondary={isSecondary}
        closeCallback={() => {
          setShowListTypeSelectionCard(false);
          setShowContentSelection(false);
          setShowListPermissionSelectionCard(false);
          setShowSortCodeSelectionCard(false);
          setHeaderText(
            props.listAction === ListAction.Edit
              ? "List Settings"
              : props.listAction === ListAction.Copy
              ? "Copy List"
              : "Add List",
          );
          setListName(listName);
          setForceOpen(false);
          props.productSet && setIsSecondary(false);
        }}
      >
        <>
          {createListError && (
            <SuccessAlert
              timerLengthInMS={3500}
              danger
              dangerText="There was an issue creating your list."
              dangerAttentionText="Please Review!"
              onClickClose={setCreateListError}
              attentionText={""}
              text={""}
            />
          )}
          {!showListTypeSelectionCard &&
            !showContentSelection &&
            !showListPermissionSelectionCard &&
            !showSortCodeSelectionCard && (
              <>
                <div className="container pt-0">
                  <div className="input-option">
                    <TextBox
                      staticLabel
                      id="listName"
                      label="List Name"
                      placeholder={(props.listAction === ListAction.Add || !props.listAction) ? "Example: My Favorite Supplies" : ""}
                      required
                      maxLength={100}
                      isValid={isListNameValid}
                      invalidFeedback={isListNameValid ? "" : listNameErrorMsg}
                      onChange={(val: string) => {
                        setListName(val);
                        setIsListNameValid(val ? true : false);
                      }}
                      value={listName}
                    />
                  </div>

                  <div className="input-option">
                    <label className="mb-0">List Type</label>
                    <div
                      className={`filter-sis-category ${
                        !showListTypeOptions ? "disabled" : ""
                      }`}
                      onClick={() => {
                        if (showListTypeOptions) {
                          setShowListTypeSelectionCard(true);
                          setHeaderText("List Type");
                          props.productSet && setIsSecondary(true);
                        }
                      }}
                    >
                      {selectedListTypeOption}
                    </div>
                  </div>

                  {manageRestrictions && (
                    <div className="input-option">
                      <label className="mb-0">Content</label>
                      <div
                        className={`filter-sis-category ${
                          props.listAction === ListAction.Edit ? "disabled" : ""
                        }`}
                        onClick={() => {
                          setShowContentSelection(true);
                          setHeaderText("Content");
                          props.productSet && setIsSecondary(true);
                        }}
                      >
                        {selectedContentType}
                      </div>
                    </div>
                  )}

                  {manageRestrictions && (
                    <div className="input-option">
                      <label className="mb-0">Permissions</label>
                      <div
                        className="filter-sis-category"
                        onClick={() => {
                          setShowListPermissionSelectionCard(true);
                          setHeaderText("Permissions");
                          props.productSet && setIsSecondary(true);
                        }}
                      >
                        {selectedListPermission}
                      </div>
                    </div>
                  )}

                  <div className="input-option">
                    <label className="mb-0">Sort By</label>
                    <div
                      className="filter-sis-category"
                      onClick={() => {
                        setShowSortCodeSelectionCard(true);
                        setHeaderText("Sort By");
                        props.productSet && setIsSecondary(true);
                      }}
                    >
                      {selectedListSortCode}
                    </div>
                  </div>

                  {shouldShowDeleteLink() && (
                    <div className="delete-list mt-4">
                      <button
                        className="btn-color add-list-btn"
                        onClick={() => setShowDeleteListModal(true)}
                      >
                        <Icon>delete</Icon>
                        <span className="add-list ml-4">Delete this List</span>
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}

          <div className="pl-4 pr-4 container filter-sis-body ">
            {showListTypeSelectionCard &&
              FAVORITES_LIST_TYPE_ARRAY.map((listType, index) => {
                return (
                  <WBMSelectionCard
                    selected={listType === selectedListTypeOption}
                    selectedId={selectedListTypeOption}
                    key={index}
                    onClick={() => {
                      setFavoriteListTypeSelected(index);
                      setSelectedListTypeOption(listType);
                    }}
                  >
                    <span>{listType}</span>
                  </WBMSelectionCard>
                );
              })}

            {showContentSelection &&
              DISPLAY_AS_LIST_ARRAY.map((contentType, index) => {
                return (
                  <WBMSelectionCard
                    disabled={
                      props.actionType === ListAction.Edit ||
                      (props.itemsToAdd &&
                        props.itemsToAdd.length > 0 &&
                        contentType === DisplayAsList[DisplayAsList.Category])
                    }
                    selected={contentType === selectedContentType}
                    selectedId={selectedContentType}
                    onClick={() => {
                      setContentTypeSelected(index);
                      setSelectedContentType(contentType);
                    }}
                  >
                    <span>{contentType}</span>
                  </WBMSelectionCard>
                );
              })}

            {showListPermissionSelectionCard &&
              listPermissions.length > 0 &&
              listPermissions.map((listPermission, index) => {
                return (
                  <WBMSelectionCard
                    selected={listPermission === selectedListPermission}
                    selectedId={selectedListPermission}
                    key={`listPermission_${index}`}
                    onClick={() => {
                      setFavoriteListPermissionSelected(index);
                      setSelectedListPermission(listPermission);
                    }}
                  >
                    <span>{listPermission}</span>
                  </WBMSelectionCard>
                );
              })}

            {showSortCodeSelectionCard &&
              FAVORITES_SORT_CODES_ARRAY.map((sortCode, index) => {
                return (
                  <WBMSelectionCard
                    selected={sortCode === selectedListSortCode}
                    selectedId={selectedListSortCode}
                    key={index}
                    onClick={() => {
                      setFavoriteSortCodeSelected(index);
                      setSelectedListSortCode(sortCode);
                    }}
                  >
                    <span>{sortCode}</span>
                  </WBMSelectionCard>
                );
              })}
          </div>

          <div className="select-done">
            {!listAddLoading ? (
              <Button className="col-12 btn-save" onClick={handleManageList}>
                SAVE
              </Button>
            ) : (
              <Button className="col-12 btn-save" disabled={true}>
                <span
                  className="spinner-border spinner-border-sm margin-right-10"
                  role="status"
                  aria-hidden="true"
                />
                Saving...
              </Button>
            )}
          </div>
          {showDeleteListmodal && (
            <ModalPopup
              isLoading={showSpinner}
              actionItem={deleteList}
              actionItemText="YES, DELETE"
              boxShadow
              header="Delete List"
              setShow
              className="header-app confirm-popup delete-list-modal"
              onClose={() => {
                setShowDeleteListModal(false);
              }}
              showCancelButton
              closeIcon
              dangerButton={true}
            >
              Are you sure you want to delete{" "}
              <strong>{props.productSet?.name}</strong>? This action will be
              final and cannot be undone.
            </ModalPopup>
          )}

          <ErrorAlert
            show={showErrorAlert}
            onClickClose={() => setShowErrorAlert(false)}
          />
        </>
      </SlideInSelection>
    </div>
  ) : (
    <>
      {props.loginHref && (
        <a href={props.loginHref} className="add-list-href">
          <Icon>add_circle_outline</Icon>
          <span className="add-list">Add List</span>
        </a>
      )}
    </>
  );
}

export default AddList;
